import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { actions } from '../../store/ducks/auth/actions';
import { actions as additionalUserActions } from '../../store/ducks/additional-users/actions';
import { sentry } from '../../utils/sentry';

const OAuthCallback = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(location.search);
        const code = urlParams.get('code');

        if (code) {
          try {
            dispatch(actions.enableLoading());

            const user = await Auth.currentAuthenticatedUser();

            if (user.attributes.email) {
              dispatch(
                additionalUserActions.updateUserId({
                  email: user.attributes.email,
                  userId: user.attributes.sub,
                }),
              );
            }

            dispatch(actions.login(user));

            history.push('/');
          } catch (error) {
            dispatch(actions.disableLoading());
            console.error('Error handling OAuth response:', error);
            sentry.captureException(error);
            history.push('/auth/login');
          }
        } else {
          dispatch(actions.disableLoading());
          console.error('No authorization code found in URL');
        }
      } catch (error) {
        dispatch(actions.disableLoading());
        console.error('Error in OAuth callback:', error);
        sentry.captureException(error);
        history.push('/auth/login');
      }
    };

    handleCallback();
  }, [dispatch, location, history]);

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: '100vh' }}
    >
      <div className="spinner spinner-primary"></div>
    </div>
  );
};

export default OAuthCallback;
